import { Users } from "lucide-react";
import { isGroupOption } from "./scopeFilterState";

/**
 * One row of a flat Location list (D36): a group carries its own mark instead of
 * sitting under a heading. Shared by the header's Location control and the Edit
 * access picker, so a group looks the same in both.
 */
export const ScopeOptionLabel = ({ option }: { option: { value: string; text: string } }) => (
  <span className="flex min-w-0 items-center gap-2">
    {isGroupOption(option.value) && (
      <span
        data-testid="group-mark"
        title="Group of communities"
        className="inline-flex"
      >
        <Users className="h-4 w-4 shrink-0 text-muted-foreground" />
      </span>
    )}
    <span className="truncate">{option.text}</span>
  </span>
);
